// Destino de um envio no Playground: telefone (com DDI e máscara) ou o `@lid`
// do contato — o identificador de privacidade que a API devolve em `sender.lid`
// e nos participantes de grupo. O envio aceita os dois, então o playground
// precisa dos dois: sem isso não há como TESTAR o caminho do @lid.
export type DestKind = 'phone' | 'lid';

/**
 * normalizeLid traduz o que a pessoa digitou no campo de @lid para o valor que
 * vai em `to`.
 *
 * Um @lid é feito só de dígitos, igual a um telefone — a diferença está no
 * sufixo. Aqui o campo escolhido já diz a intenção, então completamos o `@lid`
 * para quem colou só os dígitos. Na API isso NUNCA é adivinhado: lá, dígitos sem
 * sufixo são telefone, e é justamente o que impede o LID de ser gravado como um
 * número que não existe.
 *
 * Um endereço completo (…@lid, …@s.whatsapp.net, …@g.us) passa como veio.
 */
export function normalizeLid(raw: string): string {
  const v = raw.trim();
  if (v === '') return '';
  if (v.includes('@')) return v;
  const digits = v.replace(/\D/g, '');
  return digits ? `${digits}@lid` : '';
}
